import { render } from "./FailPayment.vue?vue&type=template&id=2f7f2b6a&scoped=true&ts=true"
import script from "./FailPayment.vue?vue&type=script&lang=ts"
export * from "./FailPayment.vue?vue&type=script&lang=ts"

import "./FailPayment.vue?vue&type=style&index=0&id=2f7f2b6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7f2b6a"]])

export default __exports__